import styles from './ContentAudit.module.scss';
import graphIcon from '../../../styles/assets/graphic.svg';

const ContentAuditReport = () => {
  return (
    <div className={styles.container}>
      <img
        src={graphIcon}
        alt="side menu icon"
      />
      <div>
        <h3 className={styles.title}>Content Audit Report</h3>
        <p className={styles.subTitle}>
          Content Audit Report provides a full view of the content provided by a
          hotel supplier.
        </p>
      </div>
    </div>
  );
};
export default ContentAuditReport;
